import { Link } from 'react-router-dom'
import { useI18n } from '../i18n'

interface Section {
  icon: string
  title: string
  items: string[]
}

/** Public /features page — the full feature map, grouped by area. Trilingual. */
export function Features() {
  const { t, tArr } = useI18n()
  const sections = tArr('features.sections') as Section[]

  return (
    <main className="mx-auto max-w-6xl px-5 py-14">
      <div className="mx-auto max-w-2xl text-center">
        <span className="chip mb-4">{t('nav.features')}</span>
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">{t('features.title')}</h1>
        <p className="mt-4 text-lg text-brand-700 dark:text-brand-200">{t('features.subtitle')}</p>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {sections.map((s, i) => (
          <section key={i} className="card flex flex-col p-6">
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-brand-100 dark:bg-brand-800 text-2xl">{s.icon}</div>
            <h2 className="mt-4 text-lg font-bold">{s.title}</h2>
            <ul className="mt-3 space-y-2">
              {s.items.map((it, j) => (
                <li key={j} className="flex gap-2.5 text-sm leading-relaxed text-brand-700 dark:text-brand-200">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-brand-400 dark:bg-brand-500" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <div className="mt-14 flex flex-col items-center gap-3">
        <Link to="/signup" className="btn-primary">{t('features.cta')}</Link>
        <Link to="/discover" className="text-sm text-brand-600 hover:underline dark:text-brand-300">{t('landing.seePublic')}</Link>
      </div>
    </main>
  )
}
